
  export default {
    props: {
      iconClass: {
        type: String,
        required: true
      },
      text: {
        type: String,
        required: true
      }

    }
  }
  